interface ArrowIconProps {
  direction?: 'left' | 'right';
  className?: string;
}

export default function ArrowIcon({ direction = 'right', className }: ArrowIconProps) {
  return (
    <svg
      className={`rtl-mirror size-4 shrink-0 ${direction === 'left' ? 'rotate-180' : ''} ${className ?? ''}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
